import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { PermissionProfileState } from './permission.state';

export const selectPermissionState = createFeatureSelector<PermissionProfileState>('permission');

export const selectUserProfile = createSelector(selectPermissionState, (state) => {
  return state.profile;
});

export const selectLoading = createSelector(selectPermissionState, (state) => state.loading);

export const selectError = createSelector(selectPermissionState, (state) => state.error);
